
import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseControl } from '../base/base-control';
import { CommonModule } from '@angular/common';
import { BaseFormControl } from '../base/base-form-control.directive';

@Component({
    selector: 'app-textarea',
    standalone: true,
    templateUrl: './textarea.component.html',
    styleUrl: './textarea.component.scss',
    imports: [
        CommonModule
    ]
})
export class TextareaComponent extends BaseFormControl<string> {

  @Input() rows = 3;
  @Input() autosize = false;
}